// extracted by mini-css-extract-plugin
export default {"container":"DragDrop_container__e-ArY","layout":"DragDrop_layout__R8pF2","filled":"DragDrop_filled__zWh4x","loading":"DragDrop_loading__Oq05A","input":"DragDrop_input__F5uPI"};